/**
 * @prettier
 * @flow
 */
import { KEY_NAME } from 'src/localStorage/getSignedOutReasonInLocalStorage';

export function setSignedOutReasonInLocalStorage(value: string | void): void {
    if (value === undefined) {
        window.localStorage.removeItem(KEY_NAME);
        return;
    }
    window.localStorage.setItem(KEY_NAME, JSON.stringify(value));
}
